<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="收款管理">
            <collection-table ref="collectionDom"></collection-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="付款管理" force-render>
            <payment-table ref="paymentDom"></payment-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </base-card>
  </div>
</template>

<script>
import baseCard from '@/CrComponents/Card/Card'
import collectionTable from './modules/collectionTable'
import paymentTable from './modules/paymentTable'

export default {
  name: 'CollectionList',
  components: {
    baseCard,
    collectionTable,
    paymentTable
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {}
    }
  },
  methods: {
    callback (key) {
      console.log(key)
    }
  }
}
</script>
